module.exports = __webpack_public_path__ + "img/table-order-count-icon.ef86b250.png";